export default "__VITE_ASSET__38fdb02e__"